import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ProductProvider } from '../providers/product.provider';
import { SelectedProductInterface } from '../data';
import { Transaction } from '../transaction/transaction';
import { UseCaseWithParam } from './common/use.case.with.params';

export interface RemoveSelectedProductsUseCaseParams {
    product: SelectedProductInterface;
}

@Injectable()
export class RemoveSelectedProductsUseCase implements UseCaseWithParam<RemoveSelectedProductsUseCaseParams, Observable<Transaction<void>>> {
    constructor(private productProvider: ProductProvider) {}

    bind(params: RemoveSelectedProductsUseCaseParams): Observable<Transaction<void>> {
        return this.productProvider.removeSelected(params.product);
    }
}
